import { render, staticRenderFns } from "./CapturePhotoMobile.vue?vue&type=template&id=4f24c050"
import script from "./CapturePhotoMobile.vue?vue&type=script&lang=js"
export * from "./CapturePhotoMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports